module.exports = __webpack_public_path__ + "img/WT-03_1125.0af679b7.png";